// useSettings.js
import { ref } from 'vue';
import api from "@/api/api";

const settings = ref([]);
const settingsLoading = ref(false);
const settingsLoaded = ref(false);

const fetchSettings = async () => {
    if(settingsLoaded.value) {
        return;
    }
    settingsLoading.value = true
    try {
        const response = await api.get('/settings/');
        settings.value = response.data;
        settingsLoaded.value = true;
    } catch (error) {
        console.error('Error fetching settings:', error);
    } finally {
        settingsLoading.value = false;
    }
};

export default function useSettings() {
    fetchSettings();
    return { settings, fetchSettings, settingsLoaded, settingsLoading };
}
